const toggle = {
    backgroundColor: '#f5f5f6',
    borderColor: '#ebebeb',
};
export default toggle;
//# sourceMappingURL=toggle.js.map